import lodash from 'lodash';
import { computed } from 'mobx';
import { BaseModel } from '../bases';
export class NoticeModel extends BaseModel {
  static NoticeModel: NoticeModel;
  constructor() {
    super();
    if (!lodash.isEmpty(NoticeModel.NoticeModel)) {
      return NoticeModel.NoticeModel;
    }
    this.onInit({ type: 'object', storageKey: 'busnotice' });
    NoticeModel.NoticeModel = this;
  }

  @computed
  get readInfoLength() {
    return this.readInfo.length;
  }
  @computed
  get readInfo() {
    return this.value.readInfo;
  }
  @computed
  get updateTime() {
    return this.value.updateTime;
  }
}
